import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;

const getSyllabusProgressDetail = async (subjectName, userId) => {
  try {
    const access_token = localStorage.getItem('access_token');
    const response = await axios.get(`${BASE_URL}syllabus/progress/detail`, {
      params: {
        subject_name: subjectName,
        user_id: userId,
      },
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${access_token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching syllabus progress detail:', error);
    throw error;
  }
};

export default getSyllabusProgressDetail;
